<template>
	<div class="container">
		<div class="issue-box" :class="{'issue-box-last':index == question_list.length-1}" v-for="(item,index) in question_list" :key="index">
			<div class="issue-title font-85 f_s_s_w"><span>{{index+1}}. {{item.name}}<span class="issue-type font-25" v-if="item.type == 1 || item.type == 2">（{{item.type | question_type}}）</span></span></div>
			<div class="uni-list" v-if="item.type == 1">
				<xhy-radio-group  class="uni-list-group">
					<xhy-radio class="uni-list-cell" readonly :checked="items.option_id == item.current"  v-for="(items, indexs) in item.option" :key="indexs" :label="items.option_name" :value="items.option_id" color="#1890FF"></xhy-radio>
				</xhy-radio-group>
			</div>
			<div class="uni-list" v-if="item.type == 2">
				<xhy-check-box-group  class="uni-list-group" >
					<xhy-check-box class="uni-list-cell" readonly v-for="(items,indexs) in item.option"  :key="indexs" :label="items.option_name" :value="items.option_id" :size="size" color="#1890FF"></xhy-check-box>
				</xhy-check-box-group>
			</div>
			<div class="uni-list" v-if="item.type == 3">
				<div class="view-textarea" :class="{'font-25':!detail,'font-65':detail}">{{detail?detail:'请根据问题描述您的具体情况'}}</div>
				<div class="detail-num">{{detail.length}}/200</div>
			</div>
		</div>
		<div class="doc-default" v-if="question_list.length==0 && !loading">
			<img src="https://images.dayiketang.com/shuju@3x.jpg" alt />
			<div class="doc-default-txt font-65">暂无数据</div>
		</div>
	</div>
</template>
<script>
	import XhyRadioGroup from '@/components/xhy-radio/xhy-radio-group';
	import XhyRadio from '@/components/xhy-radio/xhy-radio';
	import xhyCheckBox from '@/components/xhy-check-box/xhy-check-box';
	import xhyCheckBoxGroup from '@/components/xhy-check-box/xhy-check-box-group';
	import http from "../../request/http";
	export default {
		data() {
			return {
				current: '',
				select:[],
				size:16,
				detail:'',
				id:'',
				question_list:[],
				loading:true
			}
		},
		components: {
			XhyRadioGroup,
			XhyRadio,
			xhyCheckBox,
			xhyCheckBoxGroup
		},
		filters:{
			question_type(val){
				let txt  = '';
				switch (val){
					case '1':
						txt = '单选';
						break;
					case '2':
						txt = '多选';
						break;
					default:
						txt = ''
				}
				return txt;
			}
		},
		created(){
			let query = this.$route.query;
			this.id = query.id?query.id:'';
			this.loading = true;
			this.getIndex();
		},
		methods: {
			getIndex(){
				let data = {
					inquiry_id:this.id,
				}
				http.post('/api/wap/case/questionlist',data).then(res => {
					this.loading = false;
					if(res.errno == 0){
						this.question_list = res.data.list;
					}
				}).catch(err => {
					this.loading = false;
				})
				
			},
		},
	}
</script>

<style lang="css" scoped>
	.container {
		width: 100vw;
		height: 100vh;
		overflow-x: hidden;
		overflow-y: auto;
		background: #fafafa;
	}
	.pad-b-10{
		width: 100%;
		height: .5rem;
		background: #fff;
	}
	.issue-box {
		width: 100vw;
		height: auto;
		padding: 1rem 1rem .5rem;
		box-sizing: border-box;
		background: #fff;
	}

	.uni-list {
		width: 100%;
		height: auto;
		position: relative;
	}

	.uni-list-group {
		width: 100%;
	}

	.uni-list-group::after {
		content: '';
		display: block;
		clear: both;
	}

	.uni-list-cell {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		width: 50%;
		text-align: left;
		float: left;
	}

	.f_s_c,
	.f_s_s_w,.f_c_c,.f_sb_c {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.f_c_c{
		justify-content: center;
	}
	.f_sb_c{
			justify-content: space-between;
	}
	.f_s_s_w {
		align-items: flex-start;
		flex-wrap: wrap;
		align-content: flex-start;
	}

	.issue-title {
		width: 100%;
		line-height: 1.3rem;
		font-size: .9rem;
		font-weight: bold;
	}

	.issue-input {
		width: .9rem;
		height: 1.2rem;
	}

	.issue-type {
		font-weight: normal;
	}

	.issue-option {
		width: calc(100% - 1.45rem);
		height: auto;
		font-size:.8rem;
	}
	.textarea-box,.view-textarea{
		width: 100%;
		height: 6rem;
		padding:.5rem;
		border-radius: .25rem;
		background: rgba(250, 250, 250, 1);
		line-height: 1.2rem;
		font-size: 0.8rem;
		box-sizing: border-box;
		margin-top: .6rem;
	}
	.textarea-box{
		color: rgba(0,0,0,.65);
	}
	.textarea-place{
		line-height:1.2rem;
		font-size: 0.8rem;
		color: rgba(0,0,0,.25);
	}
	.bottom {
	  background: #fff;
	  height: 3.5rem;
	  box-shadow: #e2e2e2 .1rem -0.05rem 1rem;
	  padding:.4rem 1rem 0.4rem 1.5rem;
	  
	}
	.btn-left{
		height: 1.2rem;
		line-height: 1.2rem;
		width: auto;
		text-align: left;
		font-size: 0.8rem;
	}
	.submit-btn{
		width: calc(100% - 4.7rem);
		height: 2.2rem;
		border-radius: 1.1rem;
		box-shadow: 0px .2rem .2rem 0px rgba(24, 124, 255, 0.23);
		background: linear-gradient(180deg, #43a5ff 0%, #4890ff 100%);
		margin: 0;
	}
	.detail-num{
		width: 100%;
		height: 1.2rem;
		line-height: 1.2rem;
		font-size: .8rem;
		color: rgba(0,0,0,.25);
		text-align: right;
		position: absolute;
		bottom: .5rem;
		right: .5rem;
	}
	.doc-default {
		width: 100%;
		height: 100vh;
		background: #fff;
		padding-top:2rem;
	}
	
	.doc-default img {
		width: 15.9rem;
		height: 11rem;
		vertical-align: top;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
	}
	
	.doc-default-txt {
		width: 100%;
		height: 1.2rem;
		margin-top: .5rem;
		line-height: 1.2rem;
		font-size: .8rem;
		text-align: center;
	}
	.issue-box-last{
		padding:1rem 1rem 1.5rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patient_issue_info.vue